import React from "react";
//import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
//import classnames from 'classnames';
import { Link } from "react-router-dom";
//import {getDataTab} from '../../components/UserFunctions'

class LOF extends React.Component {
  render() {
    return (
      <div data-test="kpiManagerLOFComponent">
        <div className="container-fluid">
          <div className="row">
            <div className="col mt-5 mx-auto">
              <div className="card">
                <div
                  className="card-header"
                  style={{ backgroundColor: "#757AF7", color: "white" }}
                >
                  <h2>KPI Manager - List of Features</h2>
                </div>

                <div className="card card-body">
                  <table className="table table-bordered table-striped text-center">
                    <thead className="table-head">
                      <tr>
                        <th style={{ textAlign: "center" }}>
                          List of Features
                        </th>
                        <th style={{ textAlign: "center" }}> </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="table-row">
                        <td style={{ textAlign: "center" }}>
                          Autonomous Emergency Braking
                        </td>
                        <th style={{ textAlign: "center" }}>
                          <Link to="/Automatic_Emergency_Braking">
                            <button
                              href="#"
                              className="btn"
                              style={{
                                textAlign: "center",
                                color: "#ffffff",
                                fontWeight: "bold",
                              }}
                            >
                              AEB_KPI
                            </button>
                          </Link>
                        </th>
                      </tr>
                      <tr className="table-row">
                        <td style={{ textAlign: "center" }}>
                          Lane Keeping Assist
                        </td>
                        <th style={{ textAlign: "center" }}>
                          <Link to="/Lane_Keeping_Assist">
                            <button
                              className="btn"
                              style={{
                                textAlign: "center",
                                color: "#ffffff",
                                fontWeight: "bold",
                              }}
                            >
                              LKA_KPI
                            </button>
                          </Link>
                        </th>
                      </tr>

                      <tr className="table-row">
                        <td style={{ textAlign: "center" }}>
                          Adaptive Cruise Control
                        </td>
                        <th style={{ textAlign: "center" }}>
                          <Link to="/Adaptive_Cruise_Control">
                            <button
                              className="btn"
                              style={{
                                textAlign: "center",
                                color: "#ffffff",
                                fontWeight: "bold",
                              }}
                            >
                              ACC_KPI
                            </button>
                          </Link>
                        </th>
                      </tr>

                      <tr className="table-row">
                        <td style={{ textAlign: "center" }}>
                          Traffic Sign Recognition
                        </td>
                        <th style={{ textAlign: "center" }}>
                          <Link to="/Traffic_Sign_Recognition">
                            <button
                              className="btn"
                              style={{
                                textAlign: "center",
                                color: "#ffffff",
                                fontWeight: "bold",
                              }}
                            >
                              TSR_KPI
                            </button>
                          </Link>
                        </th>
                      </tr>
                      <tr className="table-row">
                        <td style={{ textAlign: "center" }}>
                          Lane Change Assist
                        </td>
                        <th style={{ textAlign: "center" }}>
                          <Link to="/Lane_Change_Assist">
                            <button
                              className="btn"
                              style={{
                                textAlign: "center",
                                color: "#ffffff",
                                fontWeight: "bold",
                              }}
                            >
                              LCA_KPI
                            </button>
                          </Link>
                        </th>
                      </tr>

                      <tr className="table-row">
                        <td style={{ textAlign: "center" }}>
                          Automatic Emergency Steering
                        </td>
                        <th style={{ textAlign: "center" }}>
                          <Link to="/Automatic_Emergency_Steering">
                            <button
                              className="btn"
                              style={{
                                textAlign: "center",
                                color: "#ffffff",
                                fontWeight: "bold",
                              }}
                            >
                              AES_KPI
                            </button>
                          </Link>
                        </th>
                      </tr>

                      <tr className="table-row">
                        <td style={{ textAlign: "center" }}>
                          Intelligent Speed Adaptation
                        </td>
                        <th style={{ textAlign: "center" }}>
                          <Link to="/Intelligent_Speed_Adaptation">
                            <button
                              className="btn"
                              style={{
                                textAlign: "center",
                                color: "#ffffff",
                                fontWeight: "bold",
                              }}
                            >
                              ISA_KPI
                            </button>
                          </Link>
                        </th>
                      </tr>

                      <tr className="table-row">
                        <td style={{ textAlign: "center" }}>
                          Blind Spot Detection System
                        </td>
                        <th style={{ textAlign: "center" }}>
                          <Link to="/Blind_Spot_Detection">
                            <button
                              className="btn"
                              style={{
                                textAlign: "center",
                                color: "#ffffff",
                                fontWeight: "bold",
                              }}
                            >
                              BSS_KPI
                            </button>
                          </Link>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }
export default LOF;
